<template>
    <v-form ref="formValidation" id="formValidation">
        <v-dialog class="text-center" :value="dialogNonData" width="500" persistent>
            <v-card>
                <v-card-title class="headline red lighten-2">
                    Données indisponible
                </v-card-title>
                <v-card-text>
                    {{errorMessage}}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" text @click="closeWindows()">
                        Quitter
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card-title>
            <h3>{{$storeCandidature.sasCandidature.Label}}</h3>
        </v-card-title>
        <v-layout row xs12>
            <v-flex id="colinfoCandidature" xs5>
                <v-card width="41%" height="88%" class="scroll">
                    <v-container>
                        <v-card id="identification" color="#1F7087" dark class="mb-1">
                            <v-card-title class="my-0 py-0 cyan darken-3">
                                Etudiant : {{identite}}
                            </v-card-title>
                            <v-list two-line class="transparent">
                                <LigneInfo label="Email : " :valeur="$storeCandidature.sasCandidature.Identification.Email"></LigneInfo>
                                <LigneInfo label="Téléphone : " :valeur="$storeCandidature.sasCandidature.Identification.Telephone"></LigneInfo>
                                <LigneInfo label="Né(e) le : " :valeur="naissance"></LigneInfo>
                                <LigneInfo label="Nationalité(s) : " :valeur="$storeCandidature.sasCandidature.Identification.Nationalite && $storeCandidature.sasCandidature.Identification.Nationalite.Lang00"></LigneInfo>
                                <LigneInfo label="Niveau d'études : " :valeur="$storeCandidature.sasCandidature.NiveauDEtudes"></LigneInfo>
                                <LigneInfo label="Adresse : " :valeur="adresse"></LigneInfo>
                                <v-spacer></v-spacer>
                            </v-list>
                        </v-card>

                        <v-card id="choixProgramme" color="#1F7087" dark class="mb-1">
                            <v-card-title class="my-0 py-0 cyan darken-3">
                                Choix de programme
                            </v-card-title>
                            <v-list two-line class="transparent">
                                <LigneInfo label="Ecole : " :valeur="$storeCandidature.sasCandidature.Ecole && $storeCandidature.sasCandidature.Ecole.Lang00"></LigneInfo>
                                <LigneInfo label="Nom programme : " :valeur="$storeCandidature.sasCandidature.ChoixProgramme.NomProgramme && $storeCandidature.sasCandidature.ChoixProgramme.NomProgramme.Label"></LigneInfo>
                                <LigneInfo label="Session : " :valeur="$storeCandidature.sasCandidature.ChoixProgramme.Session && $storeCandidature.sasCandidature.ChoixProgramme.Session.Label"></LigneInfo>
                                <LigneInfo label="Niveau d'admission : " :valeur="$storeCandidature.sasCandidature.ChoixProgramme.NiveauAdmission && $storeCandidature.sasCandidature.ChoixProgramme.NiveauAdmission.Lang00"></LigneInfo>
                                <LigneInfo label="Campus : " :valeur="$storeCandidature.sasCandidature.ChoixProgramme.Campus && $storeCandidature.sasCandidature.ChoixProgramme.Campus.Lang00"></LigneInfo>
                                <LigneInfo label="Langue d'étude : " :valeur="$storeCandidature.sasCandidature.ChoixProgramme.LangueEtude && $storeCandidature.sasCandidature.ChoixProgramme.LangueEtude.Lang00"></LigneInfo>
                                <LigneInfo label="Pôles disciplinaires : " :valeur="$storeCandidature.sasCandidature.PoleDisciplinaire && $storeCandidature.sasCandidature.PoleDisciplinaire.Lang00"></LigneInfo>
                                <LigneInfo label="Cycle : " :valeur="$storeCandidature.sasCandidature.Cycle && $storeCandidature.sasCandidature.Cycle.Lang00"></LigneInfo>
                                <LigneInfo label="Mode de finacement : " :valeur="$storeCandidature.sasCandidature.Identification.ModeDeFinancement && $storeCandidature.sasCandidature.Identification.ModeDeFinancement.Lang00"></LigneInfo>
                                <div v-if="$storeCandidature.sasCandidature.ChoixProgramme.Specialite1">
                                    <LigneInfo label="Choix spécialité 1 : " :valeur="$storeCandidature.sasCandidature.ChoixProgramme.Specialite1 && $storeCandidature.sasCandidature.ChoixProgramme.Specialite1.Lang00"></LigneInfo>
                                    <LigneInfo label="Choix spécialité 2 : " :valeur="$storeCandidature.sasCandidature.ChoixProgramme.Specialite2 && $storeCandidature.sasCandidature.ChoixProgramme.Specialite2.Lang00"></LigneInfo>
                                    <LigneInfo label="Choix spécialité 3 : " :valeur="$storeCandidature.sasCandidature.ChoixProgramme.Specialite3 && $storeCandidature.sasCandidature.ChoixProgramme.Specialite3.Lang00"></LigneInfo>
                                    <LigneInfo label="Rentrée : " :valeur="$storeCandidature.sasCandidature.ChoixProgramme.Rentree && $storeCandidature.sasCandidature.ChoixProgramme.Rentree.Lang00"></LigneInfo>
                                    <LigneInfo label="M2 Envisagé : " :valeur="$storeCandidature.sasCandidature.ChoixProgramme.M2Envisage && $storeCandidature.sasCandidature.ChoixProgramme.M2Envisage.Label"></LigneInfo>
                                </div>
                                <v-spacer></v-spacer>
                            </v-list>
                        </v-card>
                        <v-card id="anneeTerminale" color="#1F7087" dark class="mb-1" v-if="anneTerminale">
                            <v-card-title class="my-0 py-0 cyan darken-3">
                                Terminale :
                            </v-card-title>
                            <v-list two-line class="transparent">
                                <LigneInfo label="Année scolaire : " :valeur="anneTerminale.AnneeTerminale && anneTerminale.AnneeTerminale.Lang00"></LigneInfo>
                                <LigneInfo v-if="anneTerminale.EtablissementTerminale" label="Etablissement : " :valeur="anneTerminale.EtablissementTerminale.Label"></LigneInfo>
                                <LigneInfo v-else label="Etablissement :" :valeur="anneTerminale.EtablissementAutre"></LigneInfo>
                                <LigneInfo label="Code postal : " :valeur="anneTerminale.CpTerminale"></LigneInfo>
                                <LigneInfo label="Ville : " :valeur="anneTerminale.VilleTerminale"></LigneInfo>
                                <LigneInfo label="Redoublement : " :valeur="anneTerminale.RedoublementTerminale ? 'Oui' : 'Non'"></LigneInfo>
                                <v-spacer></v-spacer>
                            </v-list>
                        </v-card>
                        <v-card id="parcoursScolaire" color="#1F7087" dark class="mb-1">
                            <v-card-title class="my-0 py-0 cyan darken-3">
                                Parcours scolaires
                            </v-card-title>
                            <!-- Début Parcours scolaire -->
                            <v-data-table :headers="$storeCandidature.sasCandidature.FormulaireCandidature &&$storeCandidature.sasCandidature.FormulaireCandidature.Id == $storeCandidature.configurationClient.DescIdFormulaireBachelorsBba ? headersParcoursMini :
                                                    $storeCandidature.sasCandidature.Ecole && $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleIum ?  headersParcoursIum :
                                                    $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInternational ? headersParcoursInternational :
                                                    headersParcours"
                                          :items="parcoursScolaire" class="elevation-1 mytable" disable-pagination hide-default-footer>
                                <template v-slot:no-data>
                                    <v-alert v-if="$storeCandidature.langueFormulaire == 'en' " :value="true" color="grey lighten-3" icon="warning">
                                        No lines added
                                    </v-alert>
                                    <v-alert v-else :value="true" color="grey lighten-3" icon="warning">
                                        La liste est vide
                                    </v-alert>
                                </template>
                                <template v-slot:item={item}>
                                    <!--On n'affiche dans la liste que les parcours hors terminale (Bac) et non supprimé-->
                                    <tr v-if="!item.Supprimer && !item.AnneeTerminale">
                                        <th v-if="$storeCandidature.sasCandidature.FormulaireCandidature && $storeCandidature.sasCandidature.FormulaireCandidature.Id != $storeCandidature.configurationClient.DescIdFormulaireBachelorsBba" class="text-xs-left">{{item.DiplomeObtenu}}</th>
                                        <th v-if="$storeCandidature.sasCandidature.Ecole
                                            && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational" class="text-xs-left">
                                            {{item.AnneeScolairePostBac ? ($storeCandidature.langueFormulaire == 'en' ? item.AnneeScolairePostBac.Lang01 : item.AnneeScolairePostBac.Lang00) : ''}}
                                        </th>
                                        <th class="text-xs-left">{{item.EtablissementPostBac ? item.EtablissementPostBac.Label : item.EtablissementAutre}}</th>
                                        <th v-if="$storeCandidature.sasCandidature.Ecole
                                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational" class="text-xs-left">
                                            {{item.NiveauEtudes ? ($storeCandidature.langueFormulaire == 'en' ? item.NiveauEtudes.Lang01 : item.NiveauEtudes.Lang00) : ''}}
                                        </th>
                                        <th v-if="$storeCandidature.sasCandidature.Ecole
                                            && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum &&
                                            $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational" class="text-xs-left">
                                            {{item.TypeEtudes ? ($storeCandidature.langueFormulaire == 'en' ? item.TypeEtudes.Lang01 : item.TypeEtudes.Lang00) : ''}}
                                        </th>
                                        <th v-if="$storeCandidature.sasCandidature.Ecole
                                            && $storeCandidature.sasCandidature.FormulaireCandidature &&$storeCandidature.sasCandidature.FormulaireCandidature.Id != $storeCandidature.configurationClient.DescIdFormulaireBachelorsBba
                                            && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum &&
                                            $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational " class="text-xs-left">
                                            {{item.SpecialiteEtudes ? ($storeCandidature.langueFormulaire == 'en' ? item.SpecialiteEtudes.Lang01 : item.SpecialiteEtudes.Lang00) : ''}}
                                        </th>
                                        <th v-if="$storeCandidature.sasCandidature.Ecole
                                            && $storeCandidature.sasCandidature.FormulaireCandidature &&$storeCandidature.sasCandidature.FormulaireCandidature.Id != $storeCandidature.configurationClient.DescIdFormulaireBachelorsBba
                                            && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum &&
                                            $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational">
                                            <v-checkbox v-model="item.RedoublementPostBac" disabled hide-details></v-checkbox>
                                        </th>
                                        <th v-if="$storeCandidature.sasCandidature.Ecole
                                            && $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInternational" class="text-xs-left">
                                            {{item.AnneeDiplome ? ($storeCandidature.langueFormulaire == 'en' ? item.AnneeDiplome.Lang01 : item.AnneeDiplome.Lang00) : ''}}
                                        </th>
                                        <th v-if="$storeCandidature.sasCandidature.Ecole
                                               && $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInternational" class="text-xs-left">
                                            {{item.Pays ? ($storeCandidature.langueFormulaire == 'en' ? item.Pays.Lang01 : item.Pays.Lang00) : ''}}
                                        </th>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-card>

                        <v-card id="parcoursScolaire" color="#1F7087" dark class="mb-1">
                            <v-card-title class="my-0 py-0 cyan darken-3">
                                Langues
                            </v-card-title>
                            <!-- Début Liste langues -->
                            <v-data-table :headers="headersLangues" :items="$storeCandidature.sasCandidature.ListeLangues" class="elevation-1 mytable" disable-pagination hide-default-footer>
                                <template v-slot:no-data>
                                    <v-alert :value="true" color="grey lighten-3" icon="warning">{{$storeCandidature.langueFormulaire == 'en' ? 'List empty' : 'La liste est vide'}}</v-alert>
                                </template>
                                <template v-slot:item={item}>
                                    <tr v-if="!item.Supprimer">
                                        <th class="text-xs-left">{{ item.Type ? ($storeCandidature.langueFormulaire == 'en' ? item.Type.Lang01 : item.Type.Lang00) : ''}}</th>
                                        <th class="text-xs-left">{{ item.Langue ? ($storeCandidature.langueFormulaire == 'en' ?  item.Langue.Lang01 : item.Langue.Lang00 ): '' }}</th>
                                        <th>
                                            <v-checkbox v-model="item.Diplome" disabled hide-details></v-checkbox>
                                        </th>
                                        <th class="text-xs-left">{{ item.NomDiplome}}</th>
                                        <th class="text-xs-left">{{ item.AnneeDiplome ? ($storeCandidature.langueFormulaire == 'en' ? item.AnneeDiplome.Lang01 : item.AnneeDiplome.Lang00) : '' }}</th>
                                        <th class="text-xs-left">{{ item.Score}}</th>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-container>
                </v-card>
            </v-flex>
            <v-flex id="colDocument" xs7>
                <iframe v-if="$storeCandidature.sasCandidature.LienPjFusion || $storeCandidature.loadingCandidature"
                        style="position: fixed;  width: 58%; height: 88%"
                        :src="$storeCandidature.sasCandidature.LienPjFusion">
                </iframe>
                <div v-else class="headline center red mt-5">
                    URL dossier pdf indisponible
                </div>
            </v-flex>
        </v-layout>
    </v-form>
</template>
<script>
    import LigneInfo from "@/components/CompLineInfo";

    export default {
        components: {
            LigneInfo
        },

        data() {
            return {
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCandidature: this.$storeCandidature,
                // Flag dialog
                dialogNonData: false,
                errorMessage: 'Erreur',

                // Header de la liste
                headersParcours: [
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Degree' : 'Diplôme', value: 'diplome' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Academic Year' : 'Année scolaire', value: 'anneScolaire' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Institution' : 'Etablissement', value: 'etablissement' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Level of studies' : 'Niveau d\'études', value: 'niveauEtudes' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Type of studies' : 'Type d\'études', value: 'typeEtudes' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Speciality of studies' : 'Spacialité d\'études', value: 'specialiteEtudes' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Repeat' : 'Redoubler', value: 'redoublement' }
                ],
                // Header réduit de la liste de la liste
                headersParcoursMini: [
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Academic Year' : 'Année scolaire', value: 'anneScolaire' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Institution' : 'Etablissement', value: 'etablissement' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Level of studies' : 'Niveau d\'études', value: 'niveauEtudes' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Type of studies' : 'Type d\'études', value: 'typeEtudes' }
                ],

                // Header réduit de la liste de la liste pour Ium
                headersParcoursIum: [
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Degree' : 'Diplôme', value: 'diplome' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Academic Year' : 'Année scolaire', value: 'anneScolaire' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Institution' : 'Etablissement', value: 'etablissement' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Level of studies' : 'Niveau d\'études', value: 'niveauEtudes' }
                ],

                // Header réduit de la liste de la liste pour international
                headersParcoursInternational: [
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Degree' : 'Diplôme', value: 'diplome' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Institution' : 'Etablissement', value: 'etablissement' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Year of graduation' : 'Année d\'obtention', value: 'anneeDiplome' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Country' : 'Pays', value: 'pays' }
                ],

                headersLangues: [
                    { text: 'Type', value: 'type' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Language' : 'Langue', value: 'langue' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Degree' : 'Diplôme', value: 'diplome' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Degree name' : 'Nom dipôme', value: 'nomdiplome' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Year' : 'Année', value: 'annee' },
                    { text: 'Score', value: 'score' }
                ],
            }
        },

        computed: {
            // Construire l'isentité
            identite() {
                return (this.$storeCandidature.sasCandidature.Identification.Civilite ? this.$storeCandidature.sasCandidature.Identification.Civilite.Lang00 : '')
                    + ' ' + this.$storeCandidature.sasCandidature.Identification.NomContact
                    + ' ' + this.$storeCandidature.sasCandidature.Identification.PrenomContact
            },

            // Construire la date de naissance
            naissance() {
                return this.formatDate(this.$storeCandidature.sasCandidature.Identification.DateNaissance) + (this.$storeCandidature.sasCandidature.Identification.PaysNaissance ? (' à ' + this.$storeCandidature.sasCandidature.Identification.PaysNaissance.Lang00) : '')
            },

            // Cnstruire l'adresse
            adresse() {
                return (this.$storeCandidature.sasCandidature.Identification.Rue1 ? this.$storeCandidature.sasCandidature.Identification.Rue1 + ', ' : '')
                    + (this.$storeCandidature.sasCandidature.Identification.CP ? this.$storeCandidature.sasCandidature.Identification.CP + ' ' : '')
                    + (this.$storeCandidature.sasCandidature.Identification.Ville ? this.$storeCandidature.sasCandidature.Identification.Ville : '')
            },

            // Construire la ligne parcour scolaire année terminale
            anneTerminale() {
                if (this.$storeCandidature.sasCandidature.ListeParcoursScolaire.filter(ligne => ligne.AnneeTerminale)) {
                    return this.$storeCandidature.sasCandidature.ListeParcoursScolaire.filter(ligne => ligne.AnneeTerminale)[0]
                }
                else {
                    return null
                }
            },

            // Cobstruire la lsite parcours scolaire sans terminale
            parcoursScolaire() {
                return this.$storeCandidature.sasCandidature.ListeParcoursScolaire.filter(ligne => !ligne.AnneeTerminale)
            },

        },

        methods: {
            // Fermer la fenêtre
            closeWindows() {
                //alert('fermer');
                window.close();
            },

            // Formatage de la date
            formatDate(date) {
                if (date) { return this.$moment(String(date)).format('DD/MM/YYYY') }
                else { return '' }
            },

            // Fonction chargement de la candidature
            chargerCandidature(candidatureId, key) {
                // Appeler le web service de la candidature
                return this.$http.post("CandidatureFicheValidation?CdtId=" + candidatureId + "&Key=" + key);
            },
        },
        created() {
            // Définir le titre du formulaire
            document.title = 'Candidature - Validation'
            
            this.$storeCandidature.langueFormulaire = 'no'

            // Vérifier les paramètre d'enrée d'url
            if (!this.$route.query.cdt || !this.$route.query.kr) {
                this.errorMessage = 'Votre url n\'est pas valide, veuillez la vérifier !'
                this.dialogNonData = true
            }
            else {
                // Activer le flag de chargement
                this.$storeCandidature.loadingCandidature = true
                //Charger la configuration

                //On charge la configuration sans spécifier ni d'école ni de formulaire
                this.$storeCandidature.ChargerConfiguration(null, null)
                    .then(response => {
                        // Success
                        if (response.data) {
                            this.$storeCandidature.configurationClient = response.data;
                            this.$storeCandidature.configurationClient.Loaded = true
                        }
                    })

                // Chargement de la candidature
                this.chargerCandidature(this.$route.query.cdt, this.$route.query.kr)
                    .then(response => {
                        // Success
                        if (response.data) {
                            this.$storeCandidature.affecterSasCandidature(response.data);
                            // Arréter le flag de chargement
                            this.$storeCandidature.loadingCandidature = false
                        }
                    }) // On cas d'erreur on renvoi vers le formulaire de saisie vide
                    .catch(() => {
                        // Arréter le flag de chargement
                        this.$storeCandidature.loadingCandidature = false
                        this.errorMessage = "La Candidature est introuvable."
                        this.dialogNonData = true
                    });
            }
        }
    };
</script>
<style scoped>
    .scroll {
        overflow-y: scroll;
        position: fixed
    }

    .mytable table tr {
        background-color: #1F7087;
        border-bottom: none;
    }
</style>
